export default {
    model: 'Model',
    orthophoto: 'Orthophoto',
    obliquePhotography: 'Oblique Photography',
    laserPointCloud: 'Laser Point Cloud',
    model3D: '3D Model',
    projectName: 'Project Name',
    switchProject: 'Switch Project',
    newProject: 'New Project',
    modifyProject: 'Modify Project',
    modifyThisProject: 'Modify This Project',
    deleteThisProject: 'Delete This Project',
    isDelete: 'confirm to delete?',
    dataName: 'Data Name',
    creationTime: 'Creation Time',
    import: 'Import {name}',
    mergeEdit: 'Merge Edit',
    projectNotes: 'Project Notes',
    lastUpdated: 'Last Updated',
    modifyDataInformation: 'Modify Data Information',
    modelList: 'Model List',
    rotationSettings: 'Rotation Settings',
    rotateAroundAxis: 'Rotate around the {name} axis',
    translationSetting: 'Translation setting (unit: m)',
    translateAlongAxis: 'Translate along the {name} axis',
    modelReset: 'Model Reset',
    showTranslationAxis: 'Translation axis shown here',
    showRotationAxis: 'Axis of rotation shown here',
    fileList: 'File List',
    folderName: 'Folder Name',
    numberFiles: 'Number of files',
    size: 'Size',
    dataSize: 'Data Size',
    singleFile: 'Single File',
    folderWithPictures: 'Folder With Pictures',
    mapPointSelection: 'Map Point Selection',
    heightMode: 'Height Mode',
    closeToTheSurface: 'close to the surface',
    relativeToTheSurface: 'relative to the surface',
    state: 'State',
    altitude: 'Altitude',
    processing: 'Processing',
    dataAnomaly: 'Data Anomaly',
    normal: 'Normal',
    mapView: 'Map View',
    modelEditing: 'Model Editing',
    tip_PEDN: 'Please enter data name',
    tip_PEH: 'Please enter height',
    tip_PUFTC: 'Please upload files that conform to the 3D Tiles specification!',
    tip_PUFT: 'Note: Please upload files that comply with the 3D Tiles specification. Other formats are not supported yet.',
    tip_FCBE: 'File cannot be empty',
    tip_FEPR: 'Format error, please re-upload!',
    tip_uploadCanceled: 'Upload canceled',
    tip_TUFI: 'The upload folder is missing obj files, please upload again!',
    tip_TUFC: 'The upload folder can only have one obj file, please upload again!',
}